<!-- User Fia Applications Modal -->
<div
  style="overflow-y: auto"
  mdbModal
  #userFiaApplicationsModal="mdbModal"
  class="modal fade right"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myBasicModalLabel"
  aria-hidden="true"
  (close)="onClosed($event)"
>
  <div class="modal-dialog modal-fluid" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="showHideModal(false)">
          <span aria-hidden="true">×</span>
        </button>
        <div>
          <h4 class="modal-title" id="myModalLabel">{{ selectedUserProfile.fullName }} - FIA Applications</h4>
          <mdb-badge [ngClass]="{ 'badge-default': billingPlan === 'Premium', 'badge-info': billingPlan === 'Standard' }">{{
            billingPlan
          }}</mdb-badge>
        </div>
        <h4
          *ngIf="this.fiaLeftToApplyFor"
          class="modal-title w-50"
          style="text-align: right; margin-right: 25px"
          data-mdb-toggle="tooltip"
          data-mdb-placement="top"
          title="Total Applied for this year: {{ this.fiaLeftToApplyFor.totalAppliedForCurrentYear | number }}
Total Pin Balance: {{ this.fiaLeftToApplyFor.pinTotalAvailableBalance | number }}          
Pending Applications Total: {{ this.fiaLeftToApplyFor.totalAmountRequested | number }} ({{ this.fiaLeftToApplyFor.pendingAppCount }} apps)
FIA Available {{ this.fiaLeftToApplyFor.fiaAvailable | number }}"
        >
          FIA Left To Apply For: R {{ this.fiaLeftToApplyFor.amount | number }}
        </h4>
      </div>
      <div class="modal-body">
        <div *ngIf="!busy">
          <div class="col">
            <div *ngIf="showError" class="alert alert-danger text-center font-weight-bold" role="alert">
              {{ errorMsg }}
            </div>
          </div>
          <table mdbTable *ngIf="!busy && userFiaApplications?.length > 0" hover="true" small="true" responsive="false">
            <thead>
              <tr>
                <th scope="col" col="col-2">Status</th>
                <th scope="col" col="col-1">Applied By</th>
                <th scope="col" col="col-1">Amount</th>
                <th scope="col" col="col-1">Created</th>
                <th scope="col" col="col-1">Submitted</th>
                <th scope="col" col="col-1">Additional Docs</th>
                <th scope="col" col="col-1">Case Number</th>
                <th scope="col" col="col-1">Pin</th>
                <th scope="col" col="col-1">Pin Issue Date</th>
                <th scope="col" col="col-1">Pin Expiry Date</th>
              </tr>
            </thead>
            <tbody *ngFor="let apps of userFiaApplications">
              <tr
                (click)="toggleDooyaData(apps)"
                mdbTableCol
                [ngClass]="{
                  expired: this.hasPinExpired(apps.pin, apps.pinExpiryDate) || apps.status >= 5
                }"
              >
                <div *ngIf="apps.status" [ngSwitch]="apps.status" style="display: contents">
                  <td class="align-middle" style="color: blue" *ngSwitchCase="1">Pending</td>
                  <td class="align-middle" style="color: blue" *ngSwitchCase="2">Awaiting Relevant Material</td>
                  <td class="align-middle" style="color: orange" *ngSwitchCase="3">Review In Progress</td>
                  <td class="align-middle" style="color: green" *ngSwitchCase="4">Approved</td>
                  <td class="align-middle" style="color: red" *ngSwitchCase="5">Declined</td>
                  <td class="align-middle" style="color: grey" *ngSwitchCase="6">Expired</td>
                  <td class="align-middle" style="color: purple" *ngSwitchCase="7">Complaint</td>
                  <td class="align-middle" style="color: black" *ngSwitchCase="8">Cancelled</td>
                  <td class="align-middle" style="color: black" *ngSwitchCase="9">Deleted</td>
                  <td class="align-middle" *ngSwitchDefault>Scheduled</td>
                </div>
                <td class="align-middle">
                  {{ createdBy(apps) }}
                </td>
                <td class="align-middle">
                  {{ apps.requestedFiaAmount | currency: "ZAR" : "symbol-narrow" }}
                </td>
                <td class="align-middle">
                  {{ apps.plannedInvestmentDate | date }}
                </td>
                <td class="align-middle">
                  {{ apps.dateRequested ? (apps.dateRequested | date) : "" }}
                </td>

                <td class="align-middle">
                  {{ apps.resubmittedDate ? (apps.resubmittedDate | date) : "" }}
                </td>

                <td class="align-middle">
                  {{ apps.caseNumber ? apps.caseNumber : "" }}
                </td>
                <td class="align-middle">{{ apps.pin }}</td>
                <td class="align-middle">
                  {{ apps.pin ? (apps.pinIssueDate | date) : "" }}
                </td>
                <td class="align-middle">
                  {{ apps.pin ? (apps.pinExpiryDate | date) : "" }}
                </td>
              </tr>
              <tr *ngIf="apps.selected" style="background-color: rgb(246, 212, 77)">
                <td colspan="100%" style="border: 0 !important">
                  <table mdbTable colspan="100%" style="border: 0 !important; background-color: whitesmoke">
                    <thead>
                      <tr>
                        <th scope="col">Dooya ID</th>
                        <th scope="col">Status</th>
                        <th scope="col">Created</th>
                        <th scope="col">Submitted</th>
                        <th scope="col">Updated</th>
                        <th scope="col">Completed</th>
                        <th scope="col">State</th>
                        <th scope="col">eFiling Attempts</th>
                        <th scope="col">Last eFiling Feedback</th>
                        <th scope="col">Overdue Warning Sent</th>
                        <th scope="col">Auto Created</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngIf="apps.busy">
                        <td colspan="100%">
                          <div class="spinner-grow text-primary" role="status">
                            <span class="sr-only"></span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody>
                      <tr *ngIf="!apps.busy && apps.dooyaFiaApplication?.errorMessage">
                        <td>
                          <div class="alert alert-danger text-center font-weight-bold">
                            {{ apps.dooyaFiaApplication.errorMessage }}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody>
                      <tr *ngIf="!apps.busy && !apps.dooyaFiaApplication?.errorMessage">
                        <td>{{ apps.dooyaFiaApplication.id }}</td>
                        <td>{{ TranslateDooyaState(apps.dooyaFiaApplication.applicationState) }}</td>
                        <td>
                          {{ apps.dooyaFiaApplication.utcDateTimeCreated ? (apps.dooyaFiaApplication.utcDateTimeCreated | date) : "" }}
                        </td>
                        <td>
                          {{ apps.dooyaFiaApplication.utcDateTimeSubmitted ? (apps.dooyaFiaApplication.utcDateTimeSubmitted | date) : "" }}
                        </td>
                        <td>
                          {{ apps.dooyaFiaApplication.utcDateTimeUpdated ? (apps.dooyaFiaApplication.utcDateTimeUpdated | date) : "" }}
                        </td>
                        <td>
                          {{ apps.dooyaFiaApplication.utcDateTimeCompleted ? (apps.dooyaFiaApplication.utcDateTimeCompleted | date) : "" }}
                        </td>
                        <td>
                          <i *ngIf="!apps.dooyaFiaApplication.isComplete" class="material-icons" mdbTooltip="Not completed yet"
                            >incomplete_circle</i
                          >
                          <i *ngIf="apps.dooyaFiaApplication.isComplete" class="material-icons" mdbTooltip="Completed">circle</i>
                          <i *ngIf="!apps.dooyaFiaApplication.isSuccess" class="material-icons" mdbTooltip="Not Successful">close</i>
                          <i *ngIf="apps.dooyaFiaApplication.isSuccess" class="material-icons" mdbTooltip="Successful">check</i>
                          <i *ngIf="apps.dooyaFiaApplication.isPaused" class="material-icons" mdbTooltip="Paused">pause_circle</i>
                          <i *ngIf="apps.dooyaFiaApplication.isDeleted" class="material-icons" mdbTooltip="Deleted">delete</i>
                        </td>
                        <td>{{ apps.dooyaFiaApplication.efilingAttempts }}</td>
                        <td>{{ apps.dooyaFiaApplication.lastEfilingFeedback }}</td>
                        <td>{{ apps.dooyaFiaApplication.overdueWarningSent ? "Yes" : "No" }}</td>
                        <td>{{ apps.dooyaFiaApplication.isAutoCreatedApplication ? "Yes" : "No" }}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="col">
            <div *ngIf="!busy && userFiaApplications?.length == 0" class="alert alert-info text-center font-weight-bold" role="alert">
              No Fia Applications
            </div>
          </div>
        </div>
        <div class="col-12 text-center">
          <div *ngIf="busy" class="spinner-grow text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div class="modal-footer justify-content-right">
          <button *ngIf="!busy" type="button" mdbBtn color="trakly" class="relative waves-light" (click)="showHideModal(false)">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
